<template>
  <div class="columns users">
    <div class="column is-12">
      <div class="box">
        <h1 class="title"><i class="fa fa-users"></i> {{this.name}} list</h1>
        <router-link class="button" v-if="hasCreateNewRoute" :to="{name: $route.name + ' new'}"><i class="fa fa-plus-circle"></i>&nbsp; Create new</router-link>
        <b-table :data="models" v-if="models && Array.isArray(models)">
          <template slot-scope="props">
            <b-table-column v-for="column in columns" v-bind:key="column.field" :field="column.field" :label="column.label">
              {{props.row[column.field]}}
            </b-table-column>
            <b-table-column label="Actions" v-if="props.row.uuid">
               <router-link v-if="hasSingleRoute" :to="{name: singularName, params: {id: props.row.uuid}}" type="button" class="is-warning button is-small"><i class="fa fa-eye"></i></router-link>
            </b-table-column>

          </template>
          <template slot="bottom-left">
            test
          </template>
        </b-table>
        <pagination></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import modelMixin from '../mixins/model'
import pagination from './partials/Pagination'

export default {
  name: 'ModelIndex',
  mixins: [modelMixin],
  components: { pagination },
  data () {
    return {
    }
  },
  computed: {
    hasCreateNewRoute: function () {
      return this.$router.resolve({ name: this.$route.name + '/new' }).href !== '#/'
    },
    hasSingleRoute: function () {
      return this.$router.resolve({ name: this.singularName, params: { id: '123' } }).href !== '#/'
    }
  },
  methods: {
    log: function (item) {
      console.log(item)
    }
  }
}
</script>
